import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tags } from "./Tags";
import { UserActionsMenu } from "./UserActionsMenu";
import { Trash, Edit as EditIcon, Email } from "../../../../../assets/images/svg";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { EmailsTable } from "./EmailsTable";

export const UserRow = ({ user, onMenuItemClick, handleEmails, handlePopup, userEmailId }) => {
  const { orgName } = user;
  if (user.type === "header") {
    return <div style={{ fontWeight: "bold", marginBottom: 10, fontSize: "22px" }}>{orgName}</div>;
  }

  const {
    id,
    firstName,
    lastName,
    statuses,
    userActions: { canShowEmailSends, canReactivate, canDeleteCompletely, canDelete }
  } = user.user;

  const userProps = { ...user.user, name: lastName + ", " + firstName, orgName };
  return (
    <>
      <li color="dark1" className="group__item" key={id}>
        <div className="group__el text">
          {lastName}, {firstName}
        </div>
        <div className="group__el icons">
          <div className="group__el tags">
            <Tags statuses={statuses} />
          </div>
          <div className="group__el admin-users__menu admin-users__menu--transparent">
            <UserActionsMenu onMenuItemClick={onMenuItemClick} item={userProps} />
          </div>
          {canShowEmailSends && (
            <div className="group__el email">
              <span
                className="group__icon"
                onClick={() => handleEmails(id)}
                title="Show Sent Emails"
              >
                <Email />
              </span>
            </div>
          )}
          <div className="group__el edit">
            <span
              className="group__icon"
              onClick={() => handlePopup(userProps, "edit")}
              title="Edit"
            >
              <EditIcon />
            </span>
          </div>
          {canReactivate && (
            <div className="group__el">
              <span
                className="group__icon"
                onClick={() => handlePopup(userProps, "reactivate")}
                title="Reactivate"
              >
                <FontAwesomeIcon icon={faPowerOff} color="red" />
              </span>
            </div>
          )}
          {(canDelete || canDeleteCompletely) && (
            <div className="group__el delete">
              <span
                className="group__icon"
                onClick={() => handlePopup(userProps, "delete")}
                title={`Delete ${statuses.isDeleted ? "Completely" : ""}`}
              >
                <Trash color="#FF0000" />
              </span>
            </div>
          )}
        </div>
      </li>
      {id === userEmailId ? <EmailsTable id={id} /> : null}
    </>
  );
};
